import { RemoveItem } from '../components/modal.js';
import CartService from '../service/CartService.js';
import Learner from './learner.js';
import ECTItemsList from "./ectitemslist";

export default class CartItem extends React.Component {
  constructor(props) {
    super(props);
    var _coupon_applied = false;
    if (_couponApplied.slug && _couponApplied.data.pc_coupon_type == 1) {
      _couponApplied.applied = {};
      if (_couponApplied.data.pc_customized_data) {
        var data = JSON.parse(_couponApplied.data.pc_customized_data);
        var _index = this.props.data.type + '_' + this.props.data.id;
        if (
          this.props.data.type == 'course' ||
          this.props.data.type == 'bundle'
        ) {
          if (Object.keys(data.course_bundle).length) {
            Object.keys(data.course_bundle).map((key, index) => {
              if (key == _index) {
                _coupon_applied = true;
                _couponApplied.applied[_index] = 1;
              }
            });
          }
        } else if (this.props.data.type == 'booking_event') {
          if (Object.keys(data.training_events).length) {
            Object.keys(data.training_events).map((key, index) => {
              if (key == 'training_event_' + this.props.data.id) {
                _coupon_applied = true;
                _couponApplied.applied[_index] = 1;
              }
            });
          }
          if (Object.keys(data.training_course).length) {
            Object.keys(data.training_course).map((key, index) => {
              if (key == 'training_course_' + this.props.data.course_id) {
                _coupon_applied = true;
                _couponApplied.applied[_index] = 1;
              }
            });
          }
        }
      }
    }
    const urlParams = new URLSearchParams(window.location.search);
var myParam = urlParams.get('item');

    var data =
      this.props.data.others != undefined
        ? this.props.data.others
        : {
            id: 0,
            title: 'Loading..',
            price: 'Loading..',
            discount_price: 'Loading..',
          };
    this.state = {
      item_purchase : myParam!=null,
      id: this.props.data.id,
      name: data.title,
      price: data.inclusive_main_price,
      discount_price: data.inclusive_price,
      isfree: data.isfree,
      tax_method: data.tax_method,
      price_o: data.price,
      discount_price_o: data.discount_price,
      type: this.props.data.type,
      desc: data.description,
      count: data.count,
      img: data.image,
      data: data,
      member_data: this.props.data.member_data,
      qty:
        Object.keys(
          CartService.getLearner(
            this.props.data.type + '_' + this.props.data.id
          )
        ).length > 0
          ? Object.keys(
              CartService.getLearner(
                this.props.data.type + '_' + this.props.data.id
              )
            ).length
          : 1,
      // learnerlisting: false,
      showmodal: false,
      // addlearner: false,
      coupon_applied: _coupon_applied,
      modalitem: {
        id: this.props.data.id,
        type: this.props.data.type,
        img: data.image,
        name: data.title,
      },
      key: this.props.data.type + '_' + this.props.data.id,
      showItemList: false,
    };
    this.toggleItemList = this.toggleItemList.bind(this);
  }

  removeFromCartPopup = () => {
    this.setState({
      showmodal: true,
    });
  };

  removeFromCart = (item) => {
    console.log(item,"remove")
    if (
      _couponApplied.slug &&
      _couponApplied.data.pc_coupon_type == 1 &&
      !this.state.coupon_applied
    ) {
      // hidden because coupn is removed when an item which isnot affecred by coupon isremoved  from cart
      this.props.couponappliedtrigger();
    }
    this.props.removeFromCart(item);
  };

  dissmissmodal = () => {
    this.setState({
      showmodal: false,
      // learnerlisting: false,
      // addlearner: false
    });
  };

  refresh = () => {
    this.props.refresh();
  };

  toggleItemList() {
    this.setState(prevState => ({
        showItemList: !prevState.showItemList
    }));
  }

  render() {
    var {
      id,
      name,
      tax_method,
      price,
      price_o,
      data,
      discount_price,
      discount_price_o,
      count,
      img,
      showmodal,
      modalitem,
      qty,
      type,
      index,
      isfree,
    } = this.state;
    discount_price =
      Math.round((Number(discount_price) + Number.EPSILON) * 100) / 100;
    price = Math.round((Number(price) + Number.EPSILON) * 100) / 100;
    var mydate = new Date(data.start_date);
    var _startdate = mydate.toLocaleString('en-GB', {
      timeZone: localStorage.selected_timezone,
    });
    _startdate = _startdate.split(',');
    _startdate = _startdate[0];
    var end_price = Number(
      isfree == '0'
        ? discount_price_o == 0
          ? price_o == 0
            ? '0'
            : price_o
          : discount_price_o
        : '0'
    );
    if (data.discount_type && data.discount_type == '1' && Number(data.discount_percent) > 0)
    {
        end_price = Number(price_o) - (Number(discount_price_o))
    }
    var strik_price = Number(
      isfree == '0'
        ? discount_price_o != 0 && discount_price_o != price_o
          ? price_o == 0
            ? '0'
            : price_o
          : '0'
        : '0'
    );
    return (
      <div className="cart-block-innersec">
        <div className="w-100">
          <div className={_bfo ? 'cart-box bulk-box' : 'cart-box'}>
            <div className="sm-d-block">
              <div className="cart-img">
                <img
                  src={img}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = default_img;
                  }}
                />
              </div>
              <div className="cart-txtbar  justify-content-between">
                <div className="cart-text">
                  {data.issoldout ? (
                    <span className="sold_out_text">
                      <span className="coupon-close">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10.079"
                          height="10.061"
                          viewBox="0 0 10.079 10.061"
                        >
                          <g
                            id="noun_Close_4046821"
                            transform="translate(-3.489 -18.576)"
                          >
                            <g
                              id="Group_38"
                              data-name="Group 38"
                              transform="translate(4 19.076)"
                            >
                              <path
                                id="Path_41"
                                data-name="Path 41"
                                d="M4.758,4a.754.754,0,0,0-.525,1.294l3.228,3.23L4.237,11.75A.753.753,0,1,0,5.3,12.816L8.526,9.589l3.224,3.226a.753.753,0,1,0,1.065-1.065L9.591,8.524l3.228-3.229a.754.754,0,1,0-1.065-1.066L8.526,7.459,5.3,4.229A.753.753,0,0,0,4.758,4Z"
                                transform="translate(-4 -4)"
                                fill="#76ad94"
                                stroke="#76ad94"
                                stroke-width="1"
                                fill-rule="evenodd"
                              ></path>
                            </g>
                          </g>
                        </svg>
                      </span>
                      Sold Out
                    </span>
                  ) : (
                    <div></div>
                  )}
                  {data.isexpired ? (
                    <span className="expire_text">
                      <span className="coupon-close">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10.079"
                          height="10.061"
                          viewBox="0 0 10.079 10.061"
                        >
                          <g
                            id="noun_Close_4046821"
                            transform="translate(-3.489 -18.576)"
                          >
                            <g
                              id="Group_38"
                              data-name="Group 38"
                              transform="translate(4 19.076)"
                            >
                              <path
                                id="Path_41"
                                data-name="Path 41"
                                d="M4.758,4a.754.754,0,0,0-.525,1.294l3.228,3.23L4.237,11.75A.753.753,0,1,0,5.3,12.816L8.526,9.589l3.224,3.226a.753.753,0,1,0,1.065-1.065L9.591,8.524l3.228-3.229a.754.754,0,1,0-1.065-1.066L8.526,7.459,5.3,4.229A.753.753,0,0,0,4.758,4Z"
                                transform="translate(-4 -4)"
                                fill="#76ad94"
                                stroke="#76ad94"
                                stroke-width="1"
                                fill-rule="evenodd"
                              ></path>
                            </g>
                          </g>
                        </svg>
                      </span>
                      Event Date Expired{' '}
                    </span>
                  ) : (
                    <div></div>
                  )}
                  <h5>{name}</h5>
                  <div className="d-flex cart_purchase_info">
                    {type == 'booking_event' &&
                    !data.issoldout &&
                    !data.isexpired ? (
                      <>
                        {' '}
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={17}
                            height="18.889"
                            viewBox="0 0 17 18.889"
                          >
                            <path
                              id="Icon_material-date-range"
                              data-name="Icon material-date-range"
                              d="M10.167,11.5H8.278v1.889h1.889Zm3.778,0H12.056v1.889h1.889Zm3.778,0H15.833v1.889h1.889Zm1.889-6.611h-.944V3H16.778V4.889H9.222V3H7.333V4.889H6.389A1.88,1.88,0,0,0,4.509,6.778L4.5,20a1.888,1.888,0,0,0,1.889,1.889H19.611A1.894,1.894,0,0,0,21.5,20V6.778A1.894,1.894,0,0,0,19.611,4.889Zm0,15.111H6.389V9.611H19.611Z"
                              transform="translate(-4.5 -3)"
                              fill="#1b1c21"
                              opacity="0.5"
                            />
                          </svg>
                          Date:{_startdate}
                        </span>
                        {data.venue ? (
                          <span className="cart_item_venue">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="13.605"
                              height="19.07"
                              viewBox="0 0 13.605 19.07"
                            >
                              <path
                                id="Icon_material-place"
                                data-name="Icon material-place"
                                d="M13.3,3A5.8,5.8,0,0,0,7.5,8.8c0,4.352,5.8,10.776,5.8,10.776S19.1,13.154,19.1,8.8A5.8,5.8,0,0,0,13.3,3Zm0,7.875A2.072,2.072,0,1,1,15.375,8.8,2.073,2.073,0,0,1,13.3,10.875Z"
                                transform="translate(-6.5 -2)"
                                fill="none"
                                stroke="#1b1c21"
                                strokeWidth={2}
                                opacity="0.5"
                              />
                            </svg>
                            Venue:{data.venue}
                          </span>
                        ) : (
                          <div></div>
                        )}
                      </>
                    ) : (
                      <div className="d-flex cart_purchase_info">
                          {
                              (type== 'bundle' && data.count_course) ? ' ' + data.count_course + ' course' : ' '
                          }
                          {
                              (type== 'bundle' && data.count_training_course) ? ', ' + data.count_training_course + ' training course' : ' '
                          }
                          {
                              (type== 'bundle' && data.count_training_event) ? ', ' + data.count_training_event + ' event' : ' '
                          }
                      </div>
                    )}{' '}
                  </div>

                  {tax_method == '0' ? (
                    <div
                      className="tax-info"
                      style={{ color: '#00000042', fontSize: '10px' }}
                    >
                      * Tax Included
                    </div>
                  ) : tax_method == 2 ? (
                    <div
                      className="tax-info"
                      style={{ color: '#00000042', fontSize: '10px' }}
                    >
                      * Tax Free
                    </div>
                  ) : (
                    <div
                      className="tax-info"
                      style={{ color: '#00000042', fontSize: '10px' }}
                    >
                      * Tax Exclusive
                    </div>
                  )}
                  {data.event_warning != 0 && (
                    <EventWarning error_key={data.event_warning} />
                  )}
                </div>
              </div>

              <div className="cart-price">
                {_validMemcondition == '0' ? (
                  <div className="course-price-list">
                    <div className="d-grid">
                      <div className="courselist-cp-txt text-left gap-1">
                        {_showMember == '1' && data.member_status == '1'
                          ? _currentLabel
                          : 'Course Price'}
                      </div>
                      <div className="d-flex align-center gap-1">
                        <div className="course-price-cp pr-1">
                          {end_price == '0' ? (
                            data.item_price_label_show == '1' ? (
                              _free_course_label
                            ) : (
                              ''
                            )
                          ) : (
                            <>
                              <span className="rupee-unicode">
                                {current_currency}
                              </span>
                              {end_price}
                            </>
                          )}
                        </div>

                        {strik_price == '0' || end_price == '0' ? (
                          ''
                        ) : (
                          <div className="course-price-op line-through">
                            <span className="rupee-unicode">
                              {current_currency}
                            </span>
                            {strik_price}
                          </div>
                        )}
                      </div>
                    </div>
                    <span class="separator-price-set"></span>       
                    {_showMember == '1' && data.member_status == '1' ? (
                      <div className="d-grid">
                        <div className="courselist-mp-txt text-left">
                          {_memberLabel}
                        </div>
                        <div className="d-flex align-center justify-center">
                          <div className="course-price-mp pr-1">
                            {data.member_price > 0 && data.isfree != '1' ? (
                              <>
                                <span className="rupee-unicode">
                                  {current_currency}
                                </span>
                                {data.member_price}
                              </>
                            ) : (
                              _free_course_label
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                ) : data.member_status == '0' || _showMember == '0' ? (
                  <div className="current-price-applied-sec mb-05">
                    <span className="current-price-text">
                      {_currentLabel} Applied :{' '}
                    </span>
                    <div className="d-flex align-center ml-15 member-cp-text">
                      <div className="course-price-cp pr-1">
                        {end_price == '0' ? (
                          data.item_price_label_show == '1' ? (
                            _free_course_label
                          ) : (
                            ''
                          )
                        ) : (
                          <>
                            <span className="rupee-unicode">
                              {current_currency}
                            </span>
                            {end_price}
                          </>
                        )}
                      </div>
                      {strik_price == '0' || end_price == '0' ? (
                        ''
                      ) : (
                        <div className="course-price-op line-through">
                          <span className="rupee-unicode">
                            {current_currency}
                          </span>
                          {strik_price}
                        </div>
                      )}
                    </div>
                  </div>
                ) : _validMember == '1' ? (
                  <div className="member-price-applied-sec">
                    <span className="member-price-text">
                      {' '}
                      {_memberLabel} Applied :{' '}
                    </span>
                    <div className="d-flex align-center ml-15 member-cp-text">
                      <div className="course-price-cp pr-1">
                        {data.member_price > 0 && data.isfree != '1' ? (
                          <>
                            <span className="rupee-unicode">
                              {current_currency}
                            </span>
                            {data.member_price}
                          </>
                        ) : (
                          _free_course_label
                        )}
                      </div>

                      <div className="course-price-op line-through">
                        {end_price == '0' ? (
                          data.item_price_label_show == '1' ? (
                            _free_course_label
                          ) : (
                            ''
                          )
                        ) : (
                          <>
                            <span className="rupee-unicode">
                              {current_currency}
                            </span>
                            {end_price}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="current-price-applied-sec mb-1">
                      <span className="current-price-text">
                        {_currentLabel} Applied :
                      </span>
                      <div className="d-flex align-center ml-15 member-cp-text">
                        <div className="course-price-cp pr-1">
                          {end_price == '0' ? (
                            data.item_price_label_show == '1' ? (
                              _free_course_label
                            ) : (
                              ''
                            )
                          ) : (
                            <>
                              <span className="rupee-unicode">
                                {current_currency}
                              </span>
                              {end_price}
                            </>
                          )}
                        </div>
                        {strik_price == '0' || end_price == '0' ? (
                          ''
                        ) : (
                          <div className="course-price-op line-through">
                            <span className="rupee-unicode">
                              {current_currency}
                            </span>
                            {strik_price}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="membrship-offer-price">
                      You can avail this item for
                      <span className="member-offer-price">
                        {data.member_price > 0 && data.isfree != '1' ? (
                          <>
                            <span className="rupee-unicode">
                              {current_currency}
                            </span>
                            {data.member_price}
                          </>
                        ) : (
                          _free_course_label
                        )}
                      </span>{' '}
                      with {_memberLabel}.
                      <span className="mp-know-more-text moreinfo-tooltip">
                        Know More{' '}
                        <span className="knowmore_tooltip_content">
                          {_memberTooltipmsg}
                        </span>
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="cart-bulk-actions bulk-learner-list item-learners-wrapper">
                <div className="learner-action-list">
                {type == 'bundle' &&
                    <span className="btn-items-included" onClick={this.toggleItemList} >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-calendar-event" viewBox="0 0 16 16"><path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z"></path><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"></path></svg>
                        {(data.total_items == 0) ? '' : data.total_items} Item(s) Included 
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"></path></svg>
                    </span>
                }
                </div>
            </div>
            {this.state.showItemList && 
              <ECTItemsList 
                  courses={data.courses ? JSON.parse(data.courses) : ''}
                  trainingCourses={data.training_courses ? JSON.parse(data.training_courses) : ''}
                  trainingCoursesEvent={data.training_courses_event ? JSON.parse(data.training_courses_event) : ''}
                  trainingEvents={data.training_events ? JSON.parse(data.training_events) : ''}
                  totalItems={data.total_items}
                  index={this.state.key}
                />
            }
            {_bfo != 0 && <Learner data={this.state} refresh={this.refresh} />}
                
            {showmodal && (
              <RemoveItem
                removeFromCart={this.removeFromCart}
                dissmissmodal={this.dissmissmodal}
                img={img}
                data={modalitem}
              />
            )}
            {this.state.coupon_applied ? (
              <div className="mt-15 add-coupon-sec">
                <div className="border-bottom wd-100" />
                <div className="cart-btm-bar">
                  <div className="applied-coupon float-r">
                    <div className="coupon-tick">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10.866"
                        height="8.349"
                        viewBox="0 0 10.866 8.349"
                      >
                        <g
                          id="Group_285"
                          data-name="Group 285"
                          transform="translate(-2954.033 -3898.327)"
                        >
                          <path
                            id="Path_42"
                            data-name="Path 42"
                            d="M39.616,14.176a.612.612,0,0,0-.866,0l-5.69,5.69L31.044,17.85a.613.613,0,1,0-.866.866l2.449,2.449a.612.612,0,0,0,.866,0l6.123-6.123a.612.612,0,0,0,0-.866Z"
                            transform="translate(2924.603 3884.83)"
                            fill="#fff"
                            stroke="#fff"
                            strokeWidth={1}
                          />
                        </g>
                      </svg>
                    </div>
                    Coupon Applied
                  </div>
                </div>
              </div>
            ) : (
              <div></div>
            )}
          </div>
          <div class="trash-text" onClick={this.removeFromCartPopup}>
            <span>
              <svg
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.7"
                  d="M1 3.40002H13"
                  stroke="#1B1C21"
                  stroke-linecap="round"
                ></path>
                <path
                  opacity="0.7"
                  d="M4.25709 3.64V2.32C4.25709 1.96991 4.40158 1.63417 4.65878 1.38662C4.91597 1.13907 5.2648 1 5.62852 1H8.37138C8.73511 1 9.08393 1.13907 9.34113 1.38662C9.59832 1.63417 9.74281 1.96991 9.74281 2.32V3.64M11.8 3.64V12.88C11.8 13.2301 11.6555 13.5658 11.3983 13.8134C11.1411 14.0609 10.7922 14.2 10.4285 14.2H3.57138C3.20765 14.2 2.85883 14.0609 2.60163 13.8134C2.34444 13.5658 2.19995 13.2301 2.19995 12.88V3.64H11.8Z"
                  stroke="#1B1C21"
                  stroke-linecap="round"
                ></path>
              </svg>
              Remove This Course
            </span>
          </div>
        </div>
      </div>

    );
  }
}

export class EventWarning extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      message: ' ',
    };
    switch (this.props.error_key) {
      case 1:
        this.state = {
          message: 'Already registered an event in same course',
        };
        break;
      case 2:
        this.state = {
          message: 'Already registered to an event in same time',
        };
        break;
      case 3:
        this.state = {
          message: 'Already registered to an event in same time and course',
        };
        break;
    }
  }
  render() {
    return (
      <span className="warning-msg warning-width">
        <span className="warning-msg-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16.4"
            height="16.4"
            viewBox="0 0 16.4 16.4"
          >
            <circle
              id="Ellipse_63"
              data-name="Ellipse 63"
              cx="7.5"
              cy="7.5"
              r="7.5"
              transform="translate(0.7 0.7)"
              fill="#fff"
              stroke="#d7a30e"
              strokeWidth="1.4"
            />
            <path
              id="Path_59"
              data-name="Path 59"
              d="M822.5,583.685v4.54"
              transform="translate(-814.216 -579.681)"
              fill="none"
              stroke="#d7a30e"
              strokeLinecap="round"
              strokeWidth={2}
            />
            <path
              id="Path_60"
              data-name="Path 60"
              d="M822.5,583.725v-.04"
              transform="translate(-814.216 -572.248)"
              fill="none"
              stroke="#d7a30e"
              strokeLinecap="round"
              strokeWidth="2.4"
            />
          </svg>
        </span>
        {this.state.message}
      </span>
    );
  }
}
